import Pqp from "../../../3x1010/Pqp";
import SpriteSheetSlicer from "../../utils/SpriteSheetSlicer";

export default class ItemSlot {
	constructor(id, mc, item,compatibilities,callback) {
		this.id = id;
		this.mc = mc;
		this.item = item;
		this.sp = SpriteSheetSlicer.that;
		this.compatibilities = compatibilities;
		this.callback = callback;

		this.mouseDown = "mousedown";
		this.mouseUp = "mouseup";
		if (Pqp.isMobile()) {
			this.mouseDown = "touchstart";
			this.mouseUp = "touchend"; 
		}
	}

	hasItem() {
		if (this.item) {
			return true;
		}
		return false;
	}

	getItem() {
		return this.item;
	} 

	setItem(item) {
		this.item = item;
		item.containerPos = this.id;

		//let sprite = this.sp.getSprite(item.sheet, item.rownew, item.colnew);
		let sprite = this.sp.getSprite("items", item.rownew, item.colnew);
		if (sprite) {
			jQuery(".js-filled", this.mc).css("background-image", "url('" + sprite + "')");
			jQuery(".js-filled", this.mc).addClass("draggable")
			jQuery(".js-rarity", this.mc).css("background-image", "url('assets/ui/rarity-" + item.rarity + ".png')");
			jQuery(".js-rarity", this.mc).show();

		}


		this.mc.off(this.mouseDown);
		this.mc.off(this.mouseUp);
		//this.mc.off("click");

		this.mc.on(this.mouseDown, this.startPress.bind(this));
		this.mc.on(this.mouseUp, this.stopPress.bind(this));
		//this.mc.on("click", this.clicked.bind(this));
		this.updateQuantity();

	}

	removeItem() {
		this.mc.off(this.mouseDown);
		this.mc.off(this.mouseUp);
		//this.mc.off("click");
		this.item = null;
		jQuery(".js-filled", this.mc).css("background-image", "none");
		jQuery(".js-filled", this.mc).removeClass("draggable")
		jQuery(".js-rarity", this.mc).css("background-image", "none");
		jQuery(".js-rarity", this.mc).hide();

		this.updateQuantity();
	}


	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}



	startPress(e) {
		//e = JSON.parse(JSON.stringify(e));
		this.dispatched = false;
		//this.dispatch({ type: ItemSlot.EVENT_START_PRESS, data: { itemSlot: this, mouseEvent:e } });
		clearTimeout(this.idPress)
		this.idPress = setTimeout(this.doDispatchStartPress.bind(this,e),150);
	}

	doDispatchStartPress(e) {
		this.dispatched = true;
		this.dispatch({ type: ItemSlot.EVENT_START_PRESS, data: { itemSlot: this, mouseEvent: e } });
	}

	stopPress(e) {
		clearTimeout(this.idPress)
		if (!this.dispatched) {
			this.showItemInfo(e);
		}
	}

	showItemInfo(e) {
		this.dispatch({ type: ItemSlot.EVENT_ITEM_INFO, data: { itemSlot: this, mouseEvent: e } });
	}
	
	isCompatible(item) {
		if (!this.compatibilities) {
			return true;
		}
		let a = this.compatibilities;
		for (let x = 0; x < a.length; x++) {
			if (item.type === a[x]) {
				return true;
			}
		}
		return false;
	}

	updateQuantity() {
		let lShow = false;
		if (this.item) {
			let n = this.item.getStackQuantity();
			if (n > 1) {
				jQuery(".js-quantity", this.mc).text("" + n);
				lShow = true
			}
		}
		if (lShow) {
			jQuery(".js-quantity", this.mc).show();
		} else {
			jQuery(".js-quantity", this.mc).hide();
		}

	}
}

ItemSlot.EVENT_START_PRESS = "eventStartPress"
ItemSlot.EVENT_ITEM_INFO = "eventItemInfo"